import Dialog from '@mui/material/Dialog';
import { Box, DialogContentText } from '@mui/material';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Error from '@mui/icons-material/Error';
import { ReactNode } from 'react';
import { DEFAULT_ADVANCE_BUTTON_STYLE, DEFAULT_CANCEL_BUTTON_STYLE } from '../../utils/styleHelpers';
import { TextBlock } from './Text';

export interface DialogParams {
  open: boolean;
  setOpen: (state: boolean) => void;
  handleSubmit: () => void;
  text?: string | ReactNode;
  confirmButtonText?: string;
  title?: string;
  warningText?: string;
  disabled?: boolean;
}

export const ConfirmationModal = ({
  open,
  setOpen,
  handleSubmit,
  text = 'Are you sure?',
  confirmButtonText = 'Confirm',
  title = 'Confirmation',
  warningText,
  disabled = false
}: DialogParams) => {
  const handleClose = () => {
    setOpen(false);
  };

  const handleSubmitForm = () => {
    setOpen(false);
    handleSubmit();
  };

  return (
    <Dialog
      data-testid="confirmation-dialog"
      maxWidth="md"
      open={open}
      onClose={handleClose}>
      <DialogTitle>
        <TextBlock
          weight="bold"
          size="lg"
          color="grey9">
          {title}
        </TextBlock>
      </DialogTitle>
      <DialogContent
        sx={{
          minHeight: 70,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'left',
          overflowY: 'visible'
        }}>
        <div className="space-y-3 justify-center">{text}</div>
        {warningText && (
          <Box sx={{ display: 'flex', alignItems: 'top', marginTop: 2 }}>
            <Error sx={{ color: '#FA5D16', marginRight: 1 }} />
            <div>
              <DialogContentText sx={{ color: '#000000' }}>{warningText}</DialogContentText>
            </div>
          </Box>
        )}
      </DialogContent>
      <hr className="mb-1 mx-6" />
      <DialogActions sx={{ marginRight: 2, pb: 2 }}>
        <button
          className={DEFAULT_CANCEL_BUTTON_STYLE}
          onClick={handleClose}>
          Cancel
        </button>
        <button
          data-testid="submit-confirmation"
          onClick={handleSubmitForm}
          disabled={disabled}
          className={DEFAULT_ADVANCE_BUTTON_STYLE}
          type="submit">
          {confirmButtonText}
        </button>
      </DialogActions>
    </Dialog>
  );
};
